import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import api from "../api";

const client = api();

export default function useUserAccessesQuery(options = {}) {
  const oneHour = 1000 * 60 * 60;

  const {
    data: accessData,
    isLoading: isUserAccessesLoading,
    isError: userAccessesError,
  } = useQuery([QUERY_KEYS.USER_ACCESSES], client.getUserAccesses, {
    staleTime: oneHour * 4,
    ...options,
  });

  return {
    userAccesses: accessData?.accesses || [],
    isUserAccessesLoading,
    userAccessesError,
  };
}
